import React from 'react';
import {IntlProvider} from 'react-intl';
import {PlatformIntl} from '../../infra/PlatformIntl';

const LanguageProvider = (props) =>{
  return (
    <IntlProvider
      key={PlatformIntl.DEFAULT_LOCALE}
      locale={PlatformIntl.DEFAULT_LOCALE}
      messages={PlatformIntl.ACTIVE_MESSAGES}
    >
      {React.Children.only(props.children)}
    </IntlProvider>
  );
};

export default LanguageProvider;
